import { SvgIcon, SvgIconProps } from '@mui/material';
import styles from './ccf-sad-sentiment-icon.module.scss';

/* eslint-disable-next-line */
export interface CcfSadSentimentIconProps extends SvgIconProps {}

/**
 * Component used to display Sad Sentiment icon
 * @param props - CcfSadSentimentIconProps
 * @returns
 * @example
 */
export function CcfSadSentimentIcon(props: CcfSadSentimentIconProps) {
  return (
    <SvgIcon width="14" height="14" viewBox="0 0 14 14" fill="none" {...props}>
      <g clip-path="url(#clip0_2960_1260)">
        <path
          d="M7 0C3.15 0 0 3.15 0 7C0 10.85 3.15 14 7 14C10.85 14 14 10.85 14 7C14 3.15 10.85 0 7 0ZM7 12.6C3.92 12.6 1.4 10.08 1.4 7C1.4 3.92 3.92 1.4 7 1.4C10.08 1.4 12.6 3.92 12.6 7C12.6 10.08 10.08 12.6 7 12.6ZM4.9 6.44C5.67 6.44 6.3 5.81 6.3 5.04C6.3 4.27 5.67 3.64 4.9 3.64C4.13 3.64 3.5 4.27 3.5 5.04C3.5 5.81 4.13 6.44 4.9 6.44ZM9.1 3.64C8.33 3.64 7.7 4.27 7.7 5.04C7.7 5.81 8.33 6.44 9.1 6.44C9.87 6.44 10.5 5.81 10.5 5.04C10.5 4.27 9.87 3.64 9.1 3.64ZM7 7.91C5.53 7.91 4.34 8.54 3.57 9.52C3.57 9.59 3.5 9.73 3.5 9.87C3.5 10.22 3.78 10.5 4.2 10.5C4.48 10.5 4.62 10.36 4.76 10.15C5.32 9.52 6.16 9.1 7 9.1C7.91 9.1 8.68 9.45 9.24 10.08C9.38 10.29 9.59 10.43 9.87 10.43C10.22 10.43 10.57 10.15 10.57 9.8C10.57 9.59 10.5 9.45 10.29 9.31C9.45 8.47 8.33 7.91 7 7.91Z"
          fill="#DE5A3C"
        />
      </g>
      <defs>
        <clipPath id="clip0_2960_1260">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
}

export default CcfSadSentimentIcon;
